var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoinIcon = function SvgCoinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#748DA9",
    d: "M10.667.667a6.667 6.667 0 0 1 2.743 12.744A6.666 6.666 0 1 1 4.588 4.59 6.67 6.67 0 0 1 10.666.667m-3.334 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10m.833.833v.834h1.667V9H6.5a.417.417 0 0 0-.075.827l.075.007h1.666a2.083 2.083 0 0 1 0 4.166v.834H6.5V14H4.833v-1.666h3.333a.416.416 0 0 0 .075-.827l-.075-.007H6.5a2.083 2.083 0 0 1 0-4.166V6.5zm2.5-4.166A4.99 4.99 0 0 0 6.93 4.01a6.667 6.667 0 0 1 7.058 7.06 5 5 0 0 0-3.322-8.737"
  })));
};
export default SvgCoinIcon;